// extracted by mini-css-extract-plugin
module.exports = {"MessageComposer":"ComposeMessageModal_MessageComposer__3J427"};